export const selectJobSeekerState = (state) => state.jobSeeker;
